import {
	addResolvedPropertyMappingWithKey,
	getResolvedProperty,
	resolveMappingHasKey
} from './index';
import resolveProviderSelectedProperty from './resolveProviderSelectedProperty';
import getResolvedValue from '../utils/getResolvedValue';
import shouldAddToResolvedPropertyMapping from '../utils/shouldAddToResolvedPropertyMapping';

/**
 * Returns property selector parts for a set of properties
 * @function resolveSelectedProperties
 * @private
 *
 * @param {Object} componentRegistry - Component registry
 * @param {function} propertyResolver - Returns the value for a property
 * @param {Object} properties - A set of properties to be resolved
 * @param {Object} propertiesDef - property definition from the config
 * @param {Object} propWithSelector - A variable from the component
 * @returns {Object} - A set of resolved properties
 */
export default function resolveSelectedProperties(
	componentRegistry,
	propertyResolver,
	properties,
	propertiesDef = {},
	propWithSelector
) {
	if (Object.entries(propWithSelector).length === 0) {
		return properties;
	}

	const resolved = {...properties};
	for (const propName in propWithSelector) {
		const [id, path] = propWithSelector[propName];
		const hasBeenResolved = resolveMappingHasKey(id);

		if (hasBeenResolved) {
			const resolvedValueObj = getResolvedProperty(id);
			resolved[propName] = getResolvedValue(resolvedValueObj, path);
		} else {
			const propDef = propertiesDef[propName];
			const resolvedValue = resolveProviderSelectedProperty(
				properties[propName],
				path,
				componentRegistry,
				propDef
			);
			resolved[propName] = getResolvedValue(resolvedValue, path);
			if (shouldAddToResolvedPropertyMapping(properties[propName], componentRegistry))
				addResolvedPropertyMappingWithKey(id, resolvedValue);
		}
	}
	return resolved;
}
